import {
  characterWorkspaceHref,
  locationWorkspaceHref,
  propWorkspaceHref,
  shotWorkspaceHref,
} from "@/lib/job-subject-label"
import type { FlowNodeKind } from "@/types/flow"

type FlowNodeAssetRef = {
  kind: FlowNodeKind
  character_id: number | null
  location_id: number | null
  prop_id: number | null
  shot_id: number | null
}

/** Страница ассета, на который ссылается нода. У генераций и файлов своей страницы нет. */
export function flowNodeAssetHref(projectId: number, node: FlowNodeAssetRef): string | null {
  if (projectId <= 0) return null
  if (node.kind === "character" && node.character_id != null) {
    return characterWorkspaceHref(projectId, node.character_id)
  }
  if (node.kind === "location" && node.location_id != null) {
    return locationWorkspaceHref(projectId, node.location_id)
  }
  if (node.kind === "prop" && node.prop_id != null) {
    return propWorkspaceHref(projectId, node.prop_id)
  }
  if (node.kind === "shot" && node.shot_id != null) {
    return shotWorkspaceHref(projectId, node.shot_id)
  }
  return null
}
